'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Constants = require('ui-addon-avatars/Constants');

var _UIAvatar = require('ui-addon-avatars/UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

var _AvatarSize = require('conversations-schema/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

var _StatusIndicator = require('./StatusIndicator');

var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatHead = function (_React$Component) {
  _inherits(ChatHead, _React$Component);

  function ChatHead(props) {
    _classCallCheck(this, ChatHead);

    var _this = _possibleConstructorReturn(this, (ChatHead.__proto__ || Object.getPrototypeOf(ChatHead)).call(this, props));

    _this.renderStatus = _this.renderStatus.bind(_this);
    return _this;
  }

  _createClass(ChatHead, [{
    key: 'renderStatus',
    value: function renderStatus() {
      var _props = this.props,
          size = _props.size,
          responder = _props.responder,
          isVisitorWidget = _props.isVisitorWidget;


      if (responder) {
        return _react2.default.createElement(_StatusIndicator2.default, {
          responder: responder,
          size: size,
          isVisitorWidget: isVisitorWidget
        });
      }
      return _react2.default.createElement('div', null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          avatar = _props2.avatar,
          style = _props2.style,
          size = _props2.size,
          onClick = _props2.onClick,
          className = _props2.className,
          showStatus = _props2.showStatus,
          disabled = _props2.disabled;


      var classes = (0, _classNames2.default)('chat-head', { 'chat-head-disabled': disabled }, className);
      return _react2.default.createElement(
        'div',
        { className: classes, onClick: onClick },
        _react2.default.createElement(_UIAvatar2.default, {
          style: style,
          src: avatar,
          className: 'chat-head-avatar',
          size: size,
          type: 'contact'
        }),
        showStatus && this.renderStatus()
      );
    }
  }]);

  return ChatHead;
}(_react2.default.Component);

ChatHead.propTypes = {
  avatar: _react.PropTypes.string,
  className: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  isVisitorWidget: _react.PropTypes.bool.isRequired,
  onClick: _react.PropTypes.func,
  responder: (0, _RecordPropType2.default)('Responder'),
  showStatus: _react.PropTypes.bool.isRequired,
  size: _react.PropTypes.string.isRequired,
  style: _react.PropTypes.object
};

ChatHead.defaultProps = {
  avatar: _Constants.DEFAULT_CONTACT_AVATAR,
  away: false,
  disabled: false,
  online: false,
  showStatus: false,
  isVisitorWidget: false,
  size: _AvatarSize2.default.MEDIUM
};

exports.default = ChatHead;
module.exports = exports['default'];